import { defineComponent } from 'vue'
import { createDeferred } from '@/utils/deferred'

export function promptPdfExportDialog (parent, params) {
  const dialog = parent.$dialog
  // TODO: It seems we always fit width to pdf page now, and can remove this option.
  const { showFitWidthToPage = true, okLabel = 'Export', outerGroupName, initialData, baseZIndex } = params
  const deferred = createDeferred()

  const DialogContent = defineComponent({
    data () {
      return {
        pageOrientation: initialData?.pageOrientation ?? 'Portrait',
        includePageNum: initialData?.includePageNum ?? false,
        includeTitles: initialData?.includeTitles ?? true,
        repeatTitles: initialData?.repeatTitles ?? false,
        pageBreakPerGroup: initialData?.pageBreakPerGroup ?? false,
        fitWidthToPage: initialData?.fitWidthToPage ?? true
      }
    },
    emits: ['cancel', 'ok'],
    render () {
      return <div class="pdf-export-dialog-content">

        <div class="tw:mb-1">Layout</div>
        <div class="tw:flex tw:flex-wrap tw:gap-5 tw:mb-3">
            <div class="tw:flex tw:items-center">
                <RadioButton vModel={this.pageOrientation} inputId="portrait" name="pizza" value="Portrait" />
                <label for="portrait" class="tw:ml-2">
                  <span class="tw:mr-2">Portrait</span>
                  <font-awesome-icon icon="file-image" />
                </label>
            </div>
            <div class="tw:flex tw:items-center">
                <RadioButton vModel={this.pageOrientation} inputId="landscape" name="pizza" value="Landscape" />
                <label for="landscape" class="tw:ml-2">
                  <span class="tw:mr-2">Landscape</span>
                  <font-awesome-icon icon="image" />
                </label>
            </div>
        </div>

        { showFitWidthToPage &&
        <div class="tw:flex tw:mt-2">
          <Checkbox v-model={this.fitWidthToPage} inputId="fitWidthToPage" binary />
          <label for="fitWidthToPage" class="tw:ml-2">Fit width to page</label>
        </div>
        }

        <div class="tw:flex tw:mt-2">
          <Checkbox v-model={this.includePageNum} inputId="includePageNum" binary />
          <label for="includePageNum" class="tw:ml-2">Include page numbers</label>
        </div>

        <div class="tw:flex tw:mt-2">
          <Checkbox v-model={this.includeTitles} inputId="includeTitles" binary />
          <label for="includeTitles" class="tw:ml-2">Include titles</label>
        </div>

        { this.includeTitles &&
        <div class="tw:flex tw:mt-2">
          <Checkbox v-model={this.repeatTitles} inputId="repeatTitles" binary />
          <label for="repeatTitles" class="tw:ml-2">Repeat titles on every page</label>
        </div>
        }

        { outerGroupName &&
        <div class="tw:flex tw:mt-2">
          <Checkbox v-model={this.pageBreakPerGroup} inputId="pageBreakPerGroup" binary />
          <label for="pageBreakPerGroup" class="tw:ml-2">Print separate page per { outerGroupName }</label>
        </div>
        }

        <div class="tw:flex tw:justify-end tw:gap-2 tw:mt-4">
          <Button type="button" size="small" label="Cancel" severity="secondary" onClick={() => this.$emit('cancel')}></Button>
          <Button type="button" size="small" label={okLabel} onClick={() => this.ok()}></Button>
        </div>

      </div>
    },
    methods: {
      ok () {
        const prefs = {
          pageOrientation: this.pageOrientation,
          includePageNum: this.includePageNum,
          includeTitles: this.includeTitles,
          repeatTitles: this.repeatTitles
        }
        if (outerGroupName) {
          prefs.pageBreakPerGroup = this.pageBreakPerGroup
        }
        if (showFitWidthToPage) {
          prefs.fitWidthToPage = this.fitWidthToPage
        }
        this.$emit('ok', prefs)
      }
    },
    // TODO: Doesn't seem to get called with hot reload.
    // beforeUnmount () {
    //   if (deferred.isPending) {
    //     deferred.reject()
    //     dialogRef.close()
    //   }
    // }
  })

  const dialogRef = dialog.open(DialogContent, {
    props: {
        header: 'PDF Export Preferences',
        style: {
            width: '400px',
        },
        breakpoints:{
            '425px': '90vw',
        },
        modal: true,
        closable: false,
        dismissableMask: false,
        closeOnEscape: false,
        ...(baseZIndex ? { baseZIndex } : {})
    },
    // Documented example for PrimeVue 3 is incorrect:
    // https://github.com/primefaces/primevue/issues/5932
    emits: {
      onOk (exportPreferences) {
        deferred.resolve(exportPreferences)
        dialogRef.close()
      },
      onCancel () {
        deferred.reject()
        dialogRef.close()
      }
    }
  })

  return deferred.promise
}
